import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up\">\n  <g clip-path=\"url(#icon-up_clip0_6124_782)\">\n    <path d=\"M8 5.66601L12 9.66602L4 9.66601L8 5.66601Z\" fill=\"#00B42A\" />\n  </g>\n  <defs>\n    <clipPath id=\"icon-up_clip0_6124_782\">\n      <rect width=\"16\" height=\"16\" fill=\"white\" />\n    </clipPath>\n  </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol